// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1__b6dd4a66f79431d1db98","cls2":"SuggestedUserCard-cls2__ec5dfffdaf11a64fd774 SuggestedUserCard-cls1__b6dd4a66f79431d1db98"};